import React, { Suspense } from 'react'
import { lazyWithRetry } from '../../helper/lazyWithRetry'
import PageLoader from '../../component/Elements/pageLoader'

const Invoices = lazyWithRetry(() => import(/* webpackChunkName: "invoices" */'../../component/Invoices'))

const InvoicesPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<Invoices />
		</Suspense>
	)
})

InvoicesPage.displayName = 'InvoicesPage'
export default InvoicesPage
